import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';

@Component({
  standalone: true,
  selector: 'toast-message',
  templateUrl: './toast-message.html',
  styleUrls: ['./toast-message.scss'],
  imports: [ToastModule, CommonModule],
})
export class ToastMessage {}
